// The sign-in screen. There was no equivalent under Retool, which handled
// authentication before the app ever loaded.

import { useState } from 'react'
import { Button } from './lib/shadcn/button'
import { Input } from './lib/shadcn/input'
import { Label } from './lib/shadcn/label'
import { useAuth } from './auth'
import { APP_VERSION } from './utils/version'

export default function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    setError(null)
    setBusy(true)
    void (async () => {
      try {
        await signIn(email, password)
        // Return to wherever the session expired, when that is known.
        const next = new URLSearchParams(window.location.search).get('next')
        window.location.assign(next && next.startsWith('/') ? next : '/')
      } catch (thrown) {
        setError(thrown instanceof Error ? thrown.message : 'Could not sign in')
        setBusy(false)
      }
    })()
  }

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-5 rounded-lg border bg-card p-6 shadow-retool-md"
      >
        <div className="space-y-1">
          <h1 className="text-xl font-bold tracking-tight">Poppin' Hub</h1>
          <p className="text-sm text-muted-foreground">Sign in to continue</p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={event => setEmail(event.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </div>

        {error ? (
          <p role="alert" className="text-sm text-destructive">
            {error}
          </p>
        ) : null}

        <Button type="submit" className="w-full" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>

        <p className="text-center text-xs text-muted-foreground">v{APP_VERSION}</p>
      </form>
    </div>
  )
}
